export const appSetting = {
    ADMIN_URL: window.appSetting.ADMIN_URL,
    
    RASA_TITLE: window.appSetting.RASA_TITLE,
    TIME_REDCORE: window.appSetting.TIME_REDCORE,
    TIME_CHECK_USER: window.appSetting.TIME_CHECK_USER,
    HOTLINE: window.appSetting.HOTLINE,
}
export const CLIENT = {
    client_id: 'VPKHCN',
    client_secret: 'Q2jGsMahbmcgdHLDrG5oIGtob2EgaOG7jWMgdsOgIGPDtG5nIG5naOG7hyBxdeG7kWMgZ2lh',
    scope: 'offline_access openid',
    redirect_uri: `${window.location.protocol}//${window.location.host}/oauth-callback`,
    logout_redirect_uri: `${window.location.protocol}//${window.location.host}/logout`
};
export const AUTHORIZATION_BASE = `Basic ${btoa(CLIENT.client_id + ':' + CLIENT.client_secret)}`;

export const PATH_APILMS_V2 = window.appSetting.PATH_APILMS_V2;
export const ADMIN_URL = window.appSetting.ADMIN_URL;
export const PATH_APILOG_V2 = window.appSetting.ADMIN_URL;
export const TIME_REDCORE = window.appSetting.TIME_REDCORE;
export const TIME_CHECK_USER = window.appSetting.TIME_CHECK_USER;
export const HOTLINE = window.appSetting.HOTLINE;
